<template>
  <div class="row webmaster-filter pad-top">
    <div class="col-12">
      <MultiSelect track-by="webmaster_hash" v-model="Storage.selectedWebmaster" :options="Storage.webmasters" :multiple="true"
                   :close-on-select="false" :clear-on-select="false" :hide-selected="false" :preserve-search="true"
                   :placeholder="$t('filter.webmaster')" label="webmaster_hash" :searchable="true"
                   :disabled="disabled" ref="multiselect">
        <template slot="option" scope="props">
          <div class="option__desc">
             <span class="option__title">
                {{ props.option.webmaster_hash }} ({{ props.option.web_login }})
             </span>
          </div>
        </template>
      </MultiSelect>
    </div>
  </div>
</template>

<script>
import MultiSelect from 'vue-multiselect'
import Storage from '../../api/Storage'
import API from '../../api/API'
import Helper from '../../api/Helper'

export default {
  props: {
    disabled: {
      type: Boolean,
      required: true
    }
  },
  components: {
    MultiSelect
  },
  mounted () {
    API.getWebmastersNoGrid(Helper.getCountryList()).then(response => {
      Storage.webmasters = response.data
    })
    this.$root.$on('country_selected', () => {
      API.getWebmastersNoGrid(Helper.getCountryList()).then(response => {
        Storage.webmasters = response.data
      })
    })
    this.$refs.multiselect.$on('select', function () {
      this.search = ''
    })
  },
  data () {
    return {
      Storage: Storage
    }
  },
  methods: {
    dispatchInputAction () {
      this.$root.$emit('webmaster_selected')
    },
    reset () {
      Storage.selectedWebmaster = Storage.webmasters
      this.dispatchInputAction()
    }
  },
  beforeDestroy () {
    this.$root.$off('country_selected')
  }
}
</script>

<style>
.pad-top {
  padding-top: 5px;
}
</style>



// WEBPACK FOOTER //
// ByWebmasterFilter.vue?1f44115a